module.exports = __webpack_public_path__ + "img/scan.1569babe.png";